import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "carousel-slide" }
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "carousel-slide__text" }
const _hoisted_7 = ["innerHTML"]

export interface Props {
  header: string,
  subheader: string,
  body: string,
  smallImageFile: string,
  bigImageFile: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselSlide',
  props: {
    header: null,
    subheader: null,
    body: null,
    smallImageFile: null,
    bigImageFile: null
  },
  setup(__props: any) {

const props = __props as {
  header: string,
  subheader: string,
  body: string,
  smallImageFile: string,
  bigImageFile: string
};



const rootFolder = 'https://static.serato.com/visualizer/images/export_screen_assets/'


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("picture", null, [
      _createElementVNode("source", {
        srcset: rootFolder + __props.bigImageFile + '.webp',
        type: "image/webp",
        class: "carousel-slide__image",
        media: "(min-width: 1399px) and (min-height: 695px)",
        height: "450",
        width: "450"
      }, null, 8, _hoisted_2),
      _createElementVNode("source", {
        srcset: rootFolder + __props.smallImageFile + '.webp',
        type: "image/webp",
        class: "carousel-slide__image",
        height: "350",
        width: "350"
      }, null, 8, _hoisted_3),
      _createElementVNode("source", {
        srcset: rootFolder + __props.bigImageFile + '.jpg',
        type: "image/jpg",
        class: "carousel-slide__image",
        media: "(min-width: 1399px) and (min-height: 695px)",
        height: "450",
        width: "450"
      }, null, 8, _hoisted_4),
      _createElementVNode("img", {
        src: rootFolder + __props.smallImageFile + '.jpg',
        type: "image/jpg",
        class: "carousel-slide__image",
        height: "350",
        width: "350"
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h1", null, _toDisplayString(__props.header), 1),
      _createElementVNode("h2", null, _toDisplayString(__props.subheader), 1),
      _createElementVNode("p", { innerHTML: __props.body }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})